<div class="quick-top-up-page page-section">
    <div class="header-part">
        <h1>Quick Top-Up</h1>
        <p class="title">It’s a quick and easy way to apply funds directly to your mobile number!</p>
        <p class="smallest sub-title">It’s a quick and easy way to apply funds directly to your mobile number!</p>
    </div>
    <div class="form-box">
        <p class="smaller"><b>1. Enter your FreeUp Mobile number to verify your account:</b></p>
        <form [formGroup]="quickTopUpForm" (ngSubmit)="checkPhoneNumber()">
            <div class="form-field">
                <label class="outlined-label-input">
                    <input id="phoneNumber" type="tel" appPhoneMask [inputId]="'phoneNumber'"
                        [preValue]="quickTopUpForm.value.phoneNumber" (paste)="onPaste($event)"
                        [phoneControl]="quickTopUpForm.controls['phoneNumber']" formControlName="phoneNumber"
                        restrictNumbers placeholder=" " maxlength="14" autocomplete="off" />
                    <span>Mobile Number</span>
                </label>
                <label class="validation-message" id="required-mdn-msg"
                    *ngIf="quickTopUpForm.controls.phoneNumber.touched && !quickTopUpForm.controls.phoneNumber.value">
                    Phone number is required</label>
                <label class="validation-message" id="invalid-mdn-msg"
                    *ngIf="quickTopUpForm.controls.phoneNumber.touched && !!quickTopUpForm.controls.phoneNumber.value && quickTopUpForm.hasError('matchingDigits')">
                    Invalid phone number</label>
            </div>
            <div class="form-field last">
                <label class="outlined-label-input">
                    <input id="confirmPhoneNumber" type="tel" appPhoneMask [inputId]="'confirmPhoneNumber'"
                        [preValue]="quickTopUpForm.value.confirmPhoneNumber" (paste)="onPaste($event)"
                        [phoneControl]="quickTopUpForm.controls['confirmPhoneNumber']"
                        formControlName="confirmPhoneNumber" restrictNumbers placeholder=" " maxlength="14"
                        autocomplete="off" />
                    <span>Confirm Mobile Number</span>
                </label>
                <label class="validation-message" id="required-confirm-mdn-msg"
                    *ngIf="quickTopUpForm.controls.confirmPhoneNumber.touched && !quickTopUpForm.controls.confirmPhoneNumber.value">
                    Phone number confirmation is required</label>
                <label class="validation-message" id="invalid-confirm-mdn-msg"
                    *ngIf="quickTopUpForm.controls.confirmPhoneNumber.touched && !!quickTopUpForm.controls.confirmPhoneNumber.value && quickTopUpForm.hasError('mismatchedPhoneNumber')">
                    Phone numbers do not match</label>
            </div>
            <div class="form-actions">
                <button class="button primary" type="submit" id="verify-button">Verify</button>
            </div>
        </form>
    </div>
</div>